<h2 class="dialog-header paramount-font-class xx-large" style="color: white;">External User Registration</h2>

<mat-dialog-content class="dialog-content">
  <div class="modal-loading" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <div class="loading-text" style="color: white;">Loading…</div>
  </div>

  <form *ngIf="!loading" [formGroup]="form" class="reg-form">
    <!-- <input type="hidden" formControlName="protectedState"  /> -->
    <!-- ONE common Company field for both internal & external -->
    <!-- ONE common Company field (front-end pagination + search) -->
    <mat-form-field appearance="outline" class="full">
      <mat-label style="color: white;">Primary Company*</mat-label>
      <input matInput placeholder="Search company…" [disabled]="lockToMyCompany" [matAutocomplete]="companyAuto"
        (input)="onCompanySearchInput($any($event.target).value)" />

      <mat-autocomplete #companyAuto="matAutocomplete" [displayWith]="displayCompany">
        <mat-option *ngFor="let c of companiesPage" [value]="c" [panelClass]="'company-panel'"
          (onSelectionChange)="onCompanySelected(c)">
          {{ c.Account_Name }}
          <span class="name" *ngIf="isExternal && c.Account_Id === myCompanyId"> (your company)</span>
        </mat-option>
      </mat-autocomplete>

      <mat-hint style="color: white!important">
        <ng-container *ngIf="isInternal; else externalHint">
          Showing
          {{ (companyPageIndex * companyPageSize) + 1 }}
          -
          {{
          Math.min(
          (companyPageIndex * companyPageSize) + companyPageSize,
          companyFiltered.length
          )
          }}
          of {{ companyFiltered.length }}
          <span class="pager">
            <button mat-button type="button" style="color: white;" (click)="prevCompanyPage()"
              [disabled]="companyPageIndex===0">Prev</button>
            <button mat-button type="button" style="color: white;" (click)="nextCompanyPage()"
              [disabled]="(companyPageIndex+1)*companyPageSize >= companyFiltered.length">Next</button>
          </span>
        </ng-container>
        <ng-template #externalHint>
          External requests are limited to your company.
        </ng-template>
      </mat-hint>

      <mat-error style="color: red !important;font-size: large;"
        *ngIf="form.get('companyId')?.hasError('required')">Company is required</mat-error>
    </mat-form-field>

    <!-- TODO -->
    @if(isMobile){
    <div></div>
    }

    <!-- First Name -->
    <mat-form-field appearance="outline" class="half" [ngClass]="{'m-t-10':isMobile}">
      <mat-label style="color: white;">First Name</mat-label>
      <input matInput formControlName="firstName" maxlength="60" placeholder="Enter First Name">
      <mat-hint style="color: white!important;" align="end">{{ form.get('firstName')?.value?.length || 0
        }}/30</mat-hint>
      <mat-error style="color: red !important;font-size: large;"
        *ngIf="form.get('firstName')?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <!-- Last Name -->
    <mat-form-field appearance="outline" class="half">
      <mat-label style="color: white;">Last Name</mat-label>
      <input matInput formControlName="lastName" maxlength="60" placeholder="Enter Last Name">
      <mat-hint style="color: white !important;" align="end">{{ form.get('lastName')?.value?.length || 0
        }}/30</mat-hint>
      <mat-error style="color: red !important;font-size: large;"
        *ngIf="form.get('lastName')?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <!-- Email -->
    <mat-form-field appearance="outline" class="full">
      <mat-label style="color: white;">Email</mat-label>
      <input matInput formControlName="email" placeholder="user@company.com">
      <mat-error class="error" style="color: red !important; font-size: large;"
        *ngIf="form.get('email')?.hasError('required')">Required</mat-error>
      <mat-error class="error" style="color: red !important;font-size: large;"
        *ngIf="form.get('email')?.hasError('email')">Invalid email</mat-error>
      <mat-error class="error" style="color: red !important;font-size: large;"
        *ngIf="form.get('email')?.hasError('pattern')">Please enter a valid email address</mat-error>
      <mat-error class="error" style="color: red !important;font-size: large;"
        *ngIf="form.get('email')?.hasError('emailTaken')">{{emailTakenInfo?.message}}</mat-error>
    </mat-form-field>

    <!-- App Access (static 5, multiselect, at least one required) -->
    <div class="group full">
      <label class="group-label" style="color: white;">Request System Access</label>
      <div class="apps">
        <mat-checkbox color="white" style="border-color: white; color: white!important"
          *ngFor="let opt of visibleAppOptions; index as i" [checked]="appAccessFA.at(i).value"
          (change)="appCheckedChanged(i, $event.checked)">
          <span class="app-label">{{ opt.Key }}</span>
        </mat-checkbox>
      </div>
      <div class="error" style="color: red;font-size: medium;" *ngIf="appAccessFA.errors?.oneRequired">Select at least
        one app</div>
    </div>

    <!-- Approver (search + paging) -->
    <!-- Approver – full list, search filter, virtual scroll -->
    <!-- <mat-form-field appearance="outline" class="full">
    <mat-label>Approver</mat-label>
    <input matInput placeholder="Search approver…" (input)="onApproverSearch($any($event.target).value)">
    <mat-error *ngIf="form.get('AE_User_Id')?.hasError('required')">Approver is required</mat-error>
  </mat-form-field> -->

    <!-- :white_check_mark: CDK Virtual Scroll -->
    <!-- <cdk-virtual-scroll-viewport [itemSize]="approverItemSize" class="vs-viewport">
    <mat-nav-list class="list small">
      <a mat-list-item *cdkVirtualFor="let a of approverFiltered" class="vs-item" (click)="onApproverSelected(a)">
        <div mat-line>{{ a.AE_Name }}</div>
        <div mat-line class="muted">{{ a.Username }}</div>
      </a>
    </mat-nav-list>
  </cdk-virtual-scroll-viewport> -->

    <!-- Approver – integrated autocomplete with search, single cohesive unit -->
    <mat-form-field appearance="outline" class="full">
      <mat-label>Paramount Approver*</mat-label>

      <!-- One input: search + select in the same control -->
      <input matInput placeholder="Search approver…" [matAutocomplete]="approverAuto"
        (input)="onApproverSearch($any($event.target).value)" />

      <!-- Dropdown panel with scroll & filtered items -->
      <mat-autocomplete #approverAuto="matAutocomplete" [displayWith]="displayApprover"
        (opened)="onApproverPanelOpened()" [panelClass]="'approver-panel'"
        (optionSelected)="onApproverOptionSelected($event)">
        <mat-option *ngFor="let a of approverFiltered" [value]="a" [matTooltip]="(a?.AE_Name ?? a?.displayName)"
          matTooltipPosition="right">
          <div class="option-line">
            <span class="name">{{ a.AE_Name ?? a.displayName }}</span>

          </div>
        </mat-option>
      </mat-autocomplete>

      <mat-error style="color: red !important;" *ngIf="form.get('approverId')?.hasError('required')">
        Approver is required
      </mat-error>
    </mat-form-field>



  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-button (click)="onCancel()" style="color: white;">Cancel</button>
  <button mat-raised-button style="color: white; background-color: #0046cc; " (click)="onSave()"
    [disabled]="loading || !form.valid" [class.button-disabled]="loading || !form.valid"
    [class.button-enabled]="!(loading || !form.valid)">
    Submit</button>
  
  
</mat-dialog-actions>